export const SHIPPING_FLAT_DOLLARS = 7;